import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GerenciaArquivo } from 'src/app/@shared/models/gerencia-arquivo/gerencia-arquivo';
import { GerenciaArquivoService } from '../gerencia-arquivo.service';
import { ModalAtualizaArquivoComponent } from '../modal-atualiza-arquivo/modal-atualiza-arquivo.component';
import { ModalCadastraArquivoComponent } from '../modal-cadastra-arquivo/modal-cadastra-arquivo.component';
import { ModalPermissaoArquivoComponent } from '../modal-permissao-arquivo/modal-permissao-arquivo.component';

@Component({
  selector: 'app-cadastra-arquivo-gerencia',
  templateUrl: './cadastra-arquivo-gerencia.component.html',
  styleUrls: ['./cadastra-arquivo-gerencia.component.scss']
})
export class CadastraArquivoGerenciaComponent implements OnInit {
  isLoading: boolean = false;
  listaArquivos: GerenciaArquivo[] = [];
  public form: FormGroup;
  public displayedColumns = ['action', 'nomeArquivo', 'usuario', 'dataUpload']
  public clientes: any;


  constructor(private gerenciaArquivoService: GerenciaArquivoService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private fb: FormBuilder,) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      cliente: ['', [Validators.required]],
    });
    this.carregaItens();
  }

  get cliente() {
    return this.form.get('cliente').value;
  }

  config = {
    disableClose: true,
    width: '50%',
    data: {
      id: 0,
      arquivoId: 0
    }
  };

  carregaItens() {
    if (this.clientes == null) return;
    this.gerenciaArquivoService.obterPorClienteId(this.clientes.id).subscribe(obj => {
      this.listaArquivos = obj;
    }, error => {
      console.log(error);
    })
  }

  clienteSelecionado(obj: any) {
    this.clientes = obj;
    if (obj == null) return;
    this.carregaItens();
  }

  openNovo() {
    this.config.width = '700px';
    let modalNovoRegistro = this.dialog.open(ModalCadastraArquivoComponent, this.config);
    modalNovoRegistro.afterClosed().subscribe((result: string) => {
      if (result != undefined) {
        this.carregaItens();
      }
      modalNovoRegistro = null;
    });
  }

  remove(id: number) {
    if (id == null) return;
    this.gerenciaArquivoService.removeArquivo(id).subscribe(obj => {
      this.carregaItens();
      this.openSnackBar("Arquivo removido com sucesso");
    }, error => {
      console.log(error);
    })
  }

  openPermissao(id: number) {
    if (id == null) return;
    this.config.width = '900px';
    this.config.data.id = this.cliente.id;
    this.config.data.arquivoId = id;
    let modalNovoRegistro = this.dialog.open(ModalPermissaoArquivoComponent, this.config);
    modalNovoRegistro.afterClosed().subscribe((result: string) => {
      if (result != undefined) {
        this.carregaItens();
      }
      modalNovoRegistro = null;
    });
  }


  openAtualizaArquivo(id: number) {
    if (id == null) return;
    this.config.width = '500px';
    this.config.data.id = id;
    let modalNovoRegistro = this.dialog.open(ModalAtualizaArquivoComponent, this.config);
    modalNovoRegistro.afterClosed().subscribe((result: string) => {
      if (result != undefined) {
        this.carregaItens();
      }
      modalNovoRegistro = null;
    });
  }

  openSnackBar(message: string): any {
    this.snackBar.open(message, null, { duration: 5000 });
  }

}
